<template>

    <div class="update">

        <div class="update__top">

            <img class="update__img" src="/img/logo/fox/blue-head-white.svg">

            <h1 class="update__title">{{ $t('update_required_title') }}</h1>

            <p class="update__text">{{ $t('update_required_text') }}</p>

        </div>

        <div class="update__bottom">

            <button class="btn btn-big btn-green update__btn" @click="redirectStores">{{ $t('update_required_cta') }}</button>

        </div>
    </div>

</template>

<script>

import Share from '@/modules/share'
import UserAgent from '@/modules/userAgent'
import UserFlow from '@/modules/userFlow'

export default {

    name: 'update-app',

    mounted () {

        UserFlow.setPage(this, 'update-app')

    },

    methods: {

        redirectStores() {

            if (UserAgent.is.mobile()) {

                if (UserAgent.is.ios()) {

                    Share.downloadIosApp()

                } else if (UserAgent.is.android()) {

                    Share.downloadAndroidApp()

                }

            }

            this.$router.push({path: '/login/outlook'})

        }

    }
}
</script>

<style scoped lang="scss">

    .update {
        background-image: url("/img/background/fetch-mobile.svg");
        background-repeat: no-repeat;
        background-position: bottom;
        background-size: cover;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        color: $white;
        @media screen and (min-width: $above-tablet-length) {
            background-image: url('/img/background/fetch-desktop.svg');
        }

        &__top {
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        &__img {
            width: 80px;
            object-fit: contain;
            margin-top: 48px;
        }

        &__title {
            margin: 40px 16px 0;
            font-size: 22px;
            font-weight: bold;
            line-height: 1.27;
        }

        &__text {
            margin: 8px 16px 0;
            font-size: 15px;
            line-height: 1.33;
        }

        &__bottom {
            background-color: $white;
            width: 100%;
            padding: 0 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-top: 1px solid $silver;
        }

        &__btn {
            margin: 16px 0;
            width: auto;
            padding: 0 24px;
        }
    }

</style>
